module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.logged) ? _c('v-dialog', {
    attrs: {
      "transition": "false",
      "persistent": "",
      "width": "350"
    },
    model: {
      value: (_vm.exibirMensagem),
      callback: function($$v) {
        _vm.exibirMensagem = $$v
      },
      expression: "exibirMensagem"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v(_vm._s(this.tituloMensagem))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v(_vm._s(this.textoMensagem))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouCiente()
      }
    }
  }, [_vm._v("Ciente")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "false",
      "persistent": "",
      "width": "350"
    },
    model: {
      value: (_vm.globalLoading),
      callback: function($$v) {
        _vm.globalLoading = $$v
      },
      expression: "globalLoading"
    }
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "blue--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 5
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "headline mb-0",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Por favor, aguarde.")]), _vm._v(" "), _vm._l((_vm.globalLoadingMessageArray), function(item) {
    return _c('h3', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59530995","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/app-loading-dialog/loading.vue
// module id = 244
// module chunks = 0